export const dynamicValues = [
  'InspectionCode',
  'InspectionCount',
  'ShipName',
  'DeckName',
  'InspectionDate',
  'InspectorName',
  'Severity',
  'FindingName',
  'Frame',
  'VoyageName',
  'ReInspectionDate',
  'WorkOrder',
].map((val) => {
  return {id: val, name: val};
});
